// @flow
import React from 'react'
import FolderRail from './FolderRail'
import FileCard from './FileCard'
import UploadBlock from './UploadBlock'
import ArchivedBlock from './ArchivedBlock'
import LegacyRail from './LegacyRail'
import MigrationBanner from './MigrationBanner'
import { labelPath } from './path'
import styles from './styles.css'
import type {
  DigitalFile as DigitalFileType,
  TemplateNode,
} from 'lib/digital_file/model'

type Props = {
  bordered?: boolean,
  template: Array<TemplateNode>,
  countsByPath: { [path: string]: number },
  selectedPath: ?string,
  files: Array<DigitalFileType>,
  legacy: Array<DigitalFileType>,
  archived: Array<DigitalFileType>,
  uploading: boolean,
  onSelectPath: (path: string) => void,
  onUpload: (params: {
    path: string,
    name: string,
    content_type: string,
    data: string,
  }) => Promise<*>,
  onArchive: (id: number) => mixed,
  onRestore: (id: number) => mixed,
  onView: (key: ?string, contentType: ?string, name: ?string) => mixed,
  onDownload: (key: ?string) => mixed,
  onMove: (id: number) => mixed,
  onRename: (id: number) => mixed,
}

const Template = ({
  bordered = true,
  template,
  countsByPath,
  selectedPath,
  files,
  legacy,
  archived,
  uploading,
  onSelectPath,
  onUpload,
  onArchive,
  onRestore,
  onView,
  onDownload,
  onMove,
  onRename,
}: Props) => {
  const title = labelPath(template, selectedPath)
  const subtitle =
    files.length === 1 ? '1 document' : `${files.length} documents`
  const showMigration = legacy.length > 0
  const layoutClass = showMigration
    ? `${styles.layout} ${styles.layoutMigration}`
    : styles.layout

  return (
    <>
      <MigrationBanner count={legacy.length} />
      <div className={layoutClass}>
        {showMigration ? (
          <LegacyRail
            legacy={legacy}
            onView={onView}
            onMove={onMove}
            onRename={onRename}
          />
        ) : null}
        <FolderRail
        bordered={bordered}
        template={template}
        countsByPath={countsByPath}
        selectedPath={selectedPath}
        onSelect={onSelectPath}
      />
      <section className={bordered ? styles.mainCard : styles.mainCardFlat}>
        {selectedPath ? (
          <>
            <div className={styles.mainCardHeader}>
              <div className={styles.breadcrumb}>Selected Folder</div>
              <div className={styles.mainCardTitle}>{title}</div>
              <div className={styles.mainCardSubtitle}>{subtitle}</div>
            </div>
            <div className={styles.fileList}>
              {files.length > 0 ? (
                files.map((f) => (
                  <FileCard
                    key={f.id}
                    file={f}
                    onArchive={onArchive}
                    onView={onView}
                    onDownload={onDownload}
                    onMove={onMove}
                    onRename={onRename}
                  />
                ))
              ) : (
                <div className={styles.emptyState}>
                  No documents in this folder yet.
                </div>
              )}
            </div>
            <UploadBlock
              selectedPath={selectedPath}
              uploading={uploading}
              onUpload={onUpload}
            />
            <ArchivedBlock
              archived={archived}
              onRestore={onRestore}
              onView={onView}
              onDownload={onDownload}
            />
          </>
        ) : (
          <div className={styles.placeholder}>
            Please select a folder on the left.
          </div>
        )}
      </section>
      </div>
    </>
  )
}

export default Template
